import React from 'react';
import { DataList } from 'commons-ui';
import { LIST_ENTITY_NAMES } from 'constant';
import useDashboardActions from '../../useMessageCenterActions';
import useService from '../../utils/useService';
import { makeActionHandler } from '../../actions/handlers';
import { makeActionList } from '../../actions/list';
import { columnConfigs } from './listConfig';

const MessageCenterCardsList: React.FC<{}> = () => {
	const { getAllCardsForMessageCenter } = useService();
	const { getActionHandler, getActionList } = useDashboardActions(makeActionHandler, makeActionList);
	const actions = getActionList();

	return (
		<DataList
			fetchData={getAllCardsForMessageCenter}
			columnConfigs={columnConfigs}
			getActionHandler={getActionHandler}
			actions={actions}
			entity={LIST_ENTITY_NAMES.MESSAGE_CENTER}
			disablePagination={false}
			height='calc(100vh - 220px)'
		/>
	);
};

export default MessageCenterCardsList;
